import moment from "moment-timezone";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Check, X } from "react-feather";
import UserMonthlyUsageMinutes from "./UserMonthlyUsageMinutes";
import UserMonthlyUsageLogins from "./UserMonthlyUsageLogins";
import UserOverviewWidgetWrapper from "./UserOverviewWidgetWrapper";
import UserOverviewLabelValue from "./UserOverviewLabelValue";
import UserOverviewDetails from "./UserOverviewDetails";
// import UserMonthlyUserRank from "./UserMonthlyUserRank";

const UserOverview = ({ user, session, profile, systemAverages, setTab }) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={"6"}>
          <UserOverviewWidgetWrapper
            title={"Basic Details"}
            handleSettings={() => {
              setTab("details");
            }}
          >
            <UserOverviewDetails userPerson={user} />
          </UserOverviewWidgetWrapper>
        </Col>
        <Col xs={"6"}>
          <UserOverviewWidgetWrapper
            title={"System Access"}
            handleSettings={
              user.role === "User"
                ? () => {
                    setTab("system_access");
                  }
                : null
            }
          >
            <UserOverviewLabelValue
              label={"Status"}
              value={
                user.registered ? (
                  <>
                    <Check style={{ color: "green" }} />
                    Registered
                  </>
                ) : (
                  <>
                    <X style={{ color: "red" }} />
                    Not Registered
                  </>
                )
              }
            />
            <UserOverviewLabelValue label={"Email"} value={user.email} />
            <UserOverviewLabelValue
              label={"Access Profile"}
              value={
                user.role === "Admin" ? (
                  <i>(Administrator)</i>
                ) : (
                  profile.permissionName
                )
              }
            />
            <UserOverviewLabelValue
              label={"Permissions"}
              value={
                <>
                  {(user.role === "Admin") | user.create ? (
                    <Check style={{ color: "green" }} />
                  ) : (
                    <X style={{ color: "red" }} />
                  )}{" "}
                  Create |
                  {(user.role === "Admin") | user.edit ? (
                    <Check style={{ color: "green" }} />
                  ) : (
                    <X style={{ color: "red" }} />
                  )}{" "}
                  Edit |
                  {(user.role === "Admin") | user.delete ? (
                    <Check style={{ color: "green" }} />
                  ) : (
                    <X style={{ color: "red" }} />
                  )}{" "}
                  Delete
                </>
              }
            />
            <UserOverviewLabelValue
              label={"Last Login"}
              value={
                user?.lastLogin?.indexOf("0001-01-01") > -1
                  ? null
                  : moment(user.lastLogin).format("ddd D MMM yyyy HH:mm")
              }
            />
            <UserOverviewLabelValue
              label={"Last Seen"}
              value={
                session.lastSeen
                  ? moment(session.lastSeen).format("ddd D MMM yyyy HH:mm")
                  : null
              }
            />
          </UserOverviewWidgetWrapper>
        </Col>
        <Col xs={"6"}>
          <UserOverviewWidgetWrapper title={"Usage"}>
            {session &&
            session.sessionHistory &&
            Array.isArray(session.sessionHistory) &&
            session.sessionHistory.length > 0 ? (
              <ul>
                {session.sessionHistory.toReversed().map((value, index) => {
                  return (
                    <li key={`hist-${index}`}>
                      {moment(value.start).format("ddd D MMM yyyy HH:mm")} for{" "}
                      {moment
                        .duration(value.durationSeconds, "seconds")
                        .humanize()}
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="d-flex justify-content-center">No Data</div>
            )}
          </UserOverviewWidgetWrapper>
        </Col>
        <Col xs={"6"}>
          <UserOverviewWidgetWrapper title={"Lifetime Stats"}>
            <UserOverviewLabelValue
              label={"Total Session Count"}
              value={session.totalSessions}
            />
            <UserOverviewLabelValue
              label={"Total Session Time"}
              value={
                session.totalSessionTime
                  ? moment
                      .duration(session.totalSessionTime, "seconds")
                      .humanize()
                  : null
              }
            />
            <UserOverviewLabelValue
              label={"Lifetime Average"}
              value={
                session.lifetimeAverageSessionLength
                  ? moment
                      .duration(session.lifetimeAverageSessionLength, "seconds")
                      .humanize()
                  : null
              }
            />
          </UserOverviewWidgetWrapper>
        </Col>
        <Col xs={"6"}>
          <UserOverviewWidgetWrapper title={"Monthly Usage Minutes"}>
            <UserMonthlyUsageMinutes
              userData={{ user, session, profile }}
              systemAverages={systemAverages}
            />
          </UserOverviewWidgetWrapper>
        </Col>
        <Col xs={"6"}>
          <UserOverviewWidgetWrapper title={"Monthly Logins"}>
            <UserMonthlyUsageLogins
              userData={{ user, session, profile }}
              systemAverages={systemAverages}
            />
          </UserOverviewWidgetWrapper>
        </Col>
        {/* <Col xs={"6"}>
          <UserOverviewWidgetWrapper title={"Monthly User Rank"}>
            <UserMonthlyUserRank userData={{ user, session, profile }} />
          </UserOverviewWidgetWrapper>
        </Col> */}
      </Row>
    </React.Fragment>
  );
};

/*
{
    "id": "64ae6e9ceb635f32a28fc6c7",
    "type": "person",
    "customerId": "61755e032e69c3af8ad3a366",
    "customerName": "SRL",
    "primaryName": "Ben",
    "secondaryName": "Admin",
    "compoundName": "Ben Admin",
    "reference": "dev test 2",
    "fleetNumber": "",
    "category": "",
    "suppString1": "",
    "suppString2": "",
    "suppString3": "",
    "suppString4": "",
    "suppString5": "",
    "icon": "Boat_Black.png",
    "hashTags": [
        "demo"
    ],
    "lastSeen": "2025-05-07T11:13:06.977Z",
    "lastPosition": null,
    "lastAttendance": null,
    "lastCommand": null,
    "permissionId": null,
    "email": "ben.greet.ha.m@gmail.com",
    "role": "Admin",
    "lastLogin": "2025-05-07T12:13:06.977+01:00",
    "registered": false,
    "screenAlerts": false,
    "playSounds": false,
    "create": false,
    "edit": false,
    "delete": false,
    "textInfo": null,
    "dateInfo": null,
    "quantityInfo": null,
    "currencyInfo": null,
    "weblinkInfo": null,
    "emailInfo": null,
    "phoneInfo": null
}

{
    "id": "6811e827356b7f34d7c2acbd",
    "userId": "64ae6e9ceb635f32a28fc6c7",
    "customerId": "61755e032e69c3af8ad3a366",
    "sessionStart": "2025-05-07T12:13:06.864+01:00",
    "lastSeen": "2025-05-07T12:13:14.34+01:00",
    "sessionHistory": [
        {
            "start": "2025-05-06T11:12:23.727+01:00",
            "end": "2025-05-06T11:13:01.458+01:00",
            "durationSeconds": 37.731
        },
        {
            "start": "2025-05-06T11:36:44.148+01:00",
            "end": "2025-05-06T11:37:53.744+01:00",
            "durationSeconds": 69.596
        },
        {
            "start": "2025-05-07T09:19:13.169+01:00",
            "end": "2025-05-07T09:20:52.421+01:00",
            "durationSeconds": 99.252
        },
        {
            "start": "2025-05-07T11:36:52.465+01:00",
            "end": "2025-05-07T11:37:24.692+01:00",
            "durationSeconds": 32.227
        },
        {
            "start": "2025-05-07T12:05:59.718+01:00",
            "end": "2025-05-07T12:09:07.024+01:00",
            "durationSeconds": 187.306
        }
    ],
    "averageSessionLength": 85.22240000000001,
    "totalSessionTime": 5785.384000000002,
    "totalSessions": 65,
    "lifetimeAverageSessionLength": 89.00590769230772,
    "monthlySummary": [
        {
            "monthCode": "202504",
            "totalSessionSeconds": 2472.9509999999996,
            "totalSessions": 34
        },
        {
            "monthCode": "202505",
            "totalSessionSeconds": 3312.4329999999995,
            "totalSessions": 31
        }
    ],
    "active": true
}
    
{
    "id": "677d58b80546347875a148ad",
    "permissionName": "chris2",
    "allAssets": false,
    "createAssets": false,
    "editAssets": false,
    "deleteAssets": false,
    "allPeople": false,
    "createPeople": false,
    "editPeople": false,
    "deletePeople": false,
    "allZones": false,
    "createZones": false,
    "editZones": false,
    "deleteZones": false,
    "allRules": false,
    "createRules": false,
    "editRules": false,
    "deleteRules": false,
    "allTrackers": false,
    "createTrackers": false,
    "editTrackers": false,
    "deleteTrackers": false,
    "allTags": false,
    "createTags": false,
    "editTags": false,
    "deleteTags": false,
    "allReaders": false,
    "createReaders": false,
    "editReaders": false,
    "deleteReaders": false,
    "createNotes": false,
    "editNotes": false,
    "deleteNotes": false,
    "viewNotes": false,
    "allContacts": false,
    "createContacts": false,
    "editContacts": false,
    "deleteContacts": false,
    "allTasks": false,
    "scheduleTasks": false,
    "logTasks": false,
    "widgets": null,
    "assetWidgets": null,
    "assetCount": 1,
    "personCount": 0,
    "zoneCount": 0,
    "userCount": 1
}

*/
export default UserOverview;
